import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HybridCommunicationService } from './hybrid-communication.service';
import { LoopbackComponent } from '../loopback.component';

@Injectable({
    providedIn: 'root'
})
export class OldSitePendingChangesGuard  {
    private defectDetailsRgx = /[\/][0-9]*[\/]defects[\/]details[\/]((new)|(popup[\/][0-9]*))/g;
    private defectDetailsPopupRgx = /[\/][0-9]*[\/]defects[\/]details[\/](popup[\/][0-9]*)/g;
    private foresightSourceCodeRgx = /[\/]foresight[\/][0-9]*[\/]analysis[\/]source-code-popup/g;

    constructor(private hybridSvc: HybridCommunicationService) {}

    canDeactivate(
        component: LoopbackComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState?: RouterStateSnapshot
    ): Observable<boolean> {
        if (nextState && this.shouldSkipGuard(nextState.url, currentState.url)) {
            return of(true);
        }
        if (currentRoute.data['isPanayush'] === true) {
            return of(true);
        }
        return this.hybridSvc.canDeactivateOldSite();
    }

    shouldSkipGuard(nextUrl: string, currentUrl: string): boolean {
        if (nextUrl.match(this.defectDetailsRgx)) {
            return true;
        }
        if (nextUrl.match(this.foresightSourceCodeRgx)) {
            return true;
        }
        if (nextUrl.includes('old=true')) {
            return true;
        }
        if (currentUrl.match(this.defectDetailsPopupRgx) && (nextUrl.includes('testDetails') || nextUrl.includes('testFromList'))) {
            return true;
        }
        return false;
    }
}
